import { useNavigate } from "react-router-dom";
import GASOLINEIMG from "../../../../assets/png/1000_EFI _GASOLINE.png";
import CustomCheckbox from "./customCheckbox/CustomCheckbox";

const JourneyCard = ({ item }) => {
  const navigate = useNavigate();
  return (
    <div
      className="bg-[#F2F2F2] border border-[#292929] px-[20px] py-[60px]"
      style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
    >
      <div className="font-[Roboto]  2xl:text-[20px] xl:text-[18px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[12px] font-normal">
        {item.title}
      </div>
      <div className="font-[Roboto]  2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] font-bold">
        {item.subTitle}
      </div>
      <div className="flex flex-col">
        <div className="flex justify-center items-center">
          <div className="flex justify-center items-center 2xl:w-[350px] xl:w-[350px] ms:w-[350px] w-[200px] 2xl:h-[350px] xl:h-[350px] md:h-[350px] h-[200px]">
            <img src={item.img} alt="" width={"100%"} />
          </div>
        </div>
        <div>
          <div className="font-[Roboto]  2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#000] w-full text-center border-b-[1px] border-[#000] pb-[10px]">
            Payload Capacity
          </div>
          <div className="font-[Roboto]   2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] w-full text-center border-b-[1px] border-[#000] pb-[10px]">
            Towing Capacity
          </div>
          <div className="font-[Roboto]   2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#000] w-full text-center border-b-[1px] border-[#000] pb-[10px]">
            2WD / 4WD
          </div>

          <button
            className="rounded-md bg-[#7ABF5B] text-[#fff] py-[21px] font-[Roboto] font-bold text-center  2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] md:mt-[96px] sm:mt-[76px] mt-[66px] w-full"
            style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            onClick={() => {
              window.scrollTo(0, 200);
              navigate(item.link);
            }}
          >
            VIEW DETAILS
          </button>

          <div className="mt-[29px]">
            <div className="font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] font-normal flex items-center justify-center">
              <div>
                {" "}
                <CustomCheckbox />
              </div>
              <div className="sm:ml-[36px] ml-[5px]">
                <div className="2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] font-normal font-[Roboto]">
                  {" "}
                  Compare Models
                </div>

                {item?.Models > 0 ? (
                  <div className="2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] font-normal font-[Roboto] italic leading-[10px]">
                    {item?.Models} Models Available
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default JourneyCard;
